import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <p className="copyright">©2024-2025 NeXtBanker All rights reserved.</p>
      <p className="icp"><a href="http://beian.miit.gov.cn/">京ICP备2025141140号</a></p>
    </footer>
  );
};

export default Footer;